import { render } from "./play.svg?vue&type=template&id=ac8d7db4"
const script = {}

import exportComponent from "/buddy/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__